import React, {Component} from "react";
import {withFormik, Field} from "formik";
import ReactSelect from "../AddSchema/Select";
import {initialValuesCreator, selectObjectCreator, validationSchemaCreator} from "./dataDef";

class FormFileds extends Component {
  componentDidMount() {
    const {values, handleStateChange, type, index} = this.props;
    handleStateChange(type, values, index);
  }

  onSelectChange = (value, key) => {
    const {setValues, values, handleStateChange, type, index} = this.props;
    handleStateChange(type, {
      ...values,
      [key]: value,
    }, index);
    setValues({
      ...values,
      [key]: value,
    });

  };

  onFieldChange = (e, key) => {
    const {setValues, values, handleStateChange, type, index} = this.props;
    handleStateChange(type, {
      ...values,
      [key]: e.target.value,
    }, index);
    setValues({
      ...values,
      [key]: e.target.value,
    });

  };

  render() {
    const {dataOfSchemas, headlineName, values, errors} = this.props;
    const keys = Object.keys(dataOfSchemas.data);
    const valuesOfProperties = Object.values(dataOfSchemas.data);
    return (
      <div className="row">
        <div className="col-sm-12 mb-3">
          <h6>{headlineName + dataOfSchemas.name}</h6>
          <hr/>
          <div className='row'>
            {keys.map((key, i) => {
              if (valuesOfProperties[i].type === 'boolean') {
                const allOptions = [selectObjectCreator('No', false), selectObjectCreator('Yes', true)];
                return (
                  <div key={i} className="col-md-4 col-sm-6 col-xs-12">
                    <div className='position-relative form-group colume-flex'>
                      <label htmlFor={key}>{key} </label>
                      <ReactSelect key={i} allOptions={allOptions} selectedOption={values[key]} filedKey={key}
                                   handleChange={this.onSelectChange}/>
                    </div>
                  </div>
                );
              } else if (valuesOfProperties[i].type === 'object') {
                const allOptions = valuesOfProperties[i].choices.map(data => {
                  return selectObjectCreator(data.name, data.key);
                });
                return (
                  <div key={i} className="col-md-4 col-sm-6 col-xs-12">
                    <div className='position-relative form-group colume-flex'>
                      <label htmlFor={key}>{key} </label>
                      <ReactSelect key={i} allOptions={allOptions} selectedOption={values[key]} filedKey={key}
                                   handleChange={this.onSelectChange}/>
                    </div>
                  </div>
                )
              } else {
                return (
                  <div key={i} className="col-md-4 col-sm-6 col-xs-12">
                    <div className='position-relative form-group colume-flex'>
                      <label htmlFor={key}>{key} </label>
                      <Field type='text' name={key} onChange={(e) => this.onFieldChange(e, key)}/>
                      {errors[key] && <p style={{color:'red'}}>{errors[key]}</p>}
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    );
  }
}


export default withFormik({
  mapPropsToValues(props) {
    return initialValuesCreator(props.dataOfSchemas.data);
  },
  validationSchema: props => validationSchemaCreator(props.dataOfSchemas.data),
})(FormFileds);



// WEBPACK FOOTER //
// ./src/views/AssetSchemas/AssetSchemas/EditSchema/FormFields.js